import React, { Component } from 'react';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';
import ResultHistogram from './ResultHistogram';
import BarPlot from './BarPlot';
import Modal from '../Modal/Modal';
import FilterBar from '../FilterBar';
import { togglePlotModal, resizePlotModal, chooseRadius, toggleShowProperties, toggleShowFill, changeParameter } from '../../actions/stat';
import { dataFiltered } from '../../actions/data';
import UITool from '../uiTool/uiTool';
import QuantilePlot from '../Plots/QuantilePlot';
//import SliderUI from './SliderUI';
import numeral from 'numeral';
import FontAwesome from 'react-fontawesome';
import Select from '../react-select-2/src_no_flow';
import 'font-awesome/css/font-awesome.css';
import 'react-select/dist/react-select.css';
import '../../css/stat.css';
import stat_styles from '../../css/stat.css';

//A hard coded template, maybe this should be in the reducer?
const template = {
  buttons: {width:75, padding:20},
  plot: {width:350, height:300},
  slider: {width:320, height:40, margin:"5px 30px"}
}

class SelectRadius extends Component {

  handleChange(value){
    this.props.dispatch(chooseRadius(value));
    this.props.dispatch(dataFiltered());
  }

  render(){
    var options = Map({ "min":"Min", "mean":"Mean", "median":"Median", "max": "Max"});
    var radios = options.map( (stat,index) => {
      var active = index === this.props.radius;
      return (
        <div
          className={active ? "markerRadius active" : "markerRadius"}
          key={index}
          onClick={this.handleChange.bind(this, index)}
        >
          {stat}
        </div>
      )
    }).toList()

    return (
      <div className="selectRadius clearfix" style={{textAlign:'center'}}>
        {radios}
      </div>
    )
  }
}

class StatBarComp extends Component {

  constructor(props) {
    super(props);

    this.state = {
      filtersCollapsed: true,
      histogramCollapsed: true,
      propertyDetailsCollapsed: false,
      additionalPropertyDetailsCollapsed: true,
      plotsCollapsed: true,
      parameter: props.parameter,
      showSelectRadius: false
    }
  }

  selectParameter(val){
    let value = val ? val.value : "";
    if(value !== this.props.parameter && value !== "") {
      this.props.dispatch(changeParameter(val))
      //this.props.dispatch(fillData(value))
    }
  }

  resizePlotModal(plot,width,height){
    this.props.dispatch(resizePlotModal(plot,width,height))
  }
  togglePlotModal(plot){
    this.props.dispatch(togglePlotModal(plot));
  }
  toggleFiltersCollapsed() {
    this.setState({filtersCollapsed: !this.state.filtersCollapsed});
  }
  toggleHistogramCollapsed() {
    this.setState({histogramCollapsed: !this.state.histogramCollapsed});
  }
  togglePropertyDetailsCollapsed() {
    this.setState({propertyDetailsCollapsed: !this.state.propertyDetailsCollapsed});
  }
  toggleAdditionalPropertyDetailsCollapsed() {
    this.setState({additionalPropertyDetailsCollapsed: !this.state.additionalPropertyDetailsCollapsed});
  }
  togglePlotsCollapsed() {
    this.setState({plotsCollapsed: !this.state.plotsCollapsed});
  }
  toggleShowProperties(){
    this.props.dispatch(toggleShowProperties())
  }
  toggleShowFill(){
    this.props.dispatch(toggleShowFill())
  }

  render() {
    /* --- HOW MANY PARCELS ARE SHOWN ON THE MAP?  --- **/
    /*var parcelMessage = 'No Data';
    if(this.props.properties.size > 0) {
      var numParcels = this.props.properties.size;
      var numParcelsPlotted = this.props.properties.filter(x => x.get('visible')).size;
      parcelMessage = numParcels === numParcelsPlotted ? 'All ' + numParcels + ' properties shown' : '' + numParcelsPlotted + ' of ' + numParcels + ' properties shown';
    }*/

    /* --- UI TOOL FOR OTHER BUTTONS  --- **/
    var uiTool = (<UITool/>)

    var uiModal = this.props.showUITools ? (<Modal
      title='Spatial Tools Interface'
      body={uiTool}
      width={this.props.uiSize[0]}
      height={this.props.uiSize[1]}
      close_button={false}
      collapsible={true}
      overflow="scroll"
      onResize={this.resizePlotModal.bind(this, 'ui')}/>
    ) : null;
    /* --- END UI TOOL --- **/


    /* --- QUANTILE PLOT  --- **/
    var quantilePlot = (
      <QuantilePlot data={this.props.data.toJS()} height={this.props.quantileSize[1]} width={this.props.quantileSize[0]}/>
    )

    var quantileModal =  this.props.showQuantile ? (<Modal
      title='Quantile Plot'
      body={quantilePlot}
      width={this.props.quantileSize[0]}
      height={this.props.quantileSize[1]}
      onClose={this.togglePlotModal.bind(this, 'quantile')}
      onResize={this.resizePlotModal.bind(this, 'quantile')}/>
    ) : null;
    /* --- END QUANTILE PLOT --- **/

    let scalar = this.props.parameter.value;

    var plotData;
    //remove null and undefined values
    if(this.props.parameterType === 'Discrete') {
      plotData = this.props.data.map(row => row.get(scalar)).filter(row => row !== undefined);
    } else {
      plotData = this.props.data.map(row => +row.get(scalar)).filter(row => row !== null && row !== undefined);
    }
    let plotMax = this.props.parameterType === 'Continuous' ? plotData.max() : null;
    let plotValues = this.props.parameterType === 'Discrete' ? plotData.toSet().toList().map(cat => Map({'category': cat ? cat : 'Null', 'value': plotData.filter(x => x === cat).size })) : List();
    var plotLabel = this.props.parameter.label;
    if(!this.props.parameterType) plotData = List();
    

    //var value = this.props.parameter.label;
    /*var histLabel = ""
    switch(scalar){
        case 'location':
          histLabel = 'Max ' + value
        break
        case 'max':
          histLabel = 'Max ' + value
        break
        case 'mean':
          histLabel = 'Mean ' + value
        break
        case 'median':
          histLabel = 'Median ' + value
        break
        case 'min':
          histLabel = 'Minimum' + value
        break
        default: histLabel = ''
    }*/

    //var dataLength = this.props.data.filter(x => x.get('visible')).size
    //var gridDisabled = dataLength > 19 ? true : false;
    //var contoursDisabled = dataLength > 19 ? true : false;

    var propertyDetails = '';
    var temp;
    if(this.props.selectedProperty) {
      temp = this.props.properties.filter(x => x.get('data') !== undefined).filter(x => x.get('data').get('cty_tmk') === this.props.selectedProperty)
      //temp = this.props.unfilteredData.filter(x => x.get('cty_tmk') === this.props.selectedProperty)
      if(temp.size > 0) {
        if(temp.get(0).get('data') !== undefined) {
          propertyDetails = temp.get(0).get('data')
        } else {
          propertyDetails = temp.get(0) 
        }
      }
    }
    
  
    return (
      <div>
      {uiModal}
      {quantileModal}
      <div className="statBar">
        <div className="statBarInner" style={{height:this.props.height}}>
          <div id='locationControl' className='cf'>
            <div className='plot-toggle-header'>
              <h5>Properties</h5>
              { /*<h6>{parcelMessage}</h6> */}
            </div>

             <div  style={{padding:'5px 20px', zIndex: 10000}}>
              <Select
                value={{value: this.props.parameter.value, label: this.props.parameter.label }}
                options={this.props.selectOptions}
                onChange={this.selectParameter.bind(this)}
                clearable={false}
                style={{'textAlign':'left'}}
              />
            </div>
            <div style={{textAlign:'center',paddingBottom:4}}>Property Statistic</div>
            { this.state.showSelectRadius ? (<div  style={{padding:'5px', zIndex: 10000}}>
              <SelectRadius
                activeRadius="max"
                dispatch={this.props.dispatch}
                radius={scalar}
                template={template.buttons}
              />
            </div>) : null }
            { scalar !== 'location' && (
            <div className='cf'>
              <div className='statCheckbox statCheckboxLone' onClick={this.toggleShowFill.bind(this)}>
                <span><FontAwesome name={this.props.fillProperties ? 'check-square' : 'square'} className="icon-left far"/></span>
                  Fill Properties
              </div>

              <div className='statCheckbox statCheckboxLone' onClick={this.toggleShowProperties.bind(this)}>
                <span><FontAwesome name={this.props.showProperties ? 'check-square' : 'square'} className="icon-left far"/></span>
                  Outline Properties
              </div>
            </div>
            )}
          </div>

          <div className="plot-toggle-header" onClick={this.toggleFiltersCollapsed.bind(this)} style={{'cursor': 'pointer'}}>
            <span><FontAwesome className="icon-right" name={this.state.filtersCollapsed ? 'chevron-right' : 'chevron-down'} /></span>
            <h5>Filters</h5>
          </div>
          <div className={this.state.filtersCollapsed ? 'collapse' : 'collapse show'}>
            <FilterBar width={stat_styles.filtersWidth} margin={stat_styles.filtersMarginLeft} />
          </div>

          {/*<div className="plot-toggle-header" onClick={this.togglePlotsCollapsed.bind(this)} style={{'cursor': 'pointer'}}>
            <span><FontAwesome className="icon-right" name={this.state.plotsCollapsed ? 'chevron-right' : 'chevron-down'} /></span>
            <h5>Additional Plots & Layers</h5>
          </div>
          <div className={this.state.plotsCollapsed ? 'collapse' : 'collapse show'}>
            <button type="button" className={this.props.showHotSpot ? 'btn btn-info plot-toggle toggled-on' : 'btn btn-info plot-toggle'} id='hotspotButton' onClick={this.togglePlotModal.bind(this, 'hotspot')}>Hot Spot Layer</button>
            <button type="button" disabled={gridDisabled} className={this.props.showGrid ? 'btn btn-info plot-toggle toggled-on' : 'btn btn-info plot-toggle'} id='gridButton' onClick={this.togglePlotModal.bind(this, 'grid')}>IDW Interpolation Grid</button>
            <button type="button" disabled={contoursDisabled} className={this.props.showContours ? 'btn btn-info plot-toggle toggled-on' : 'btn btn-info plot-toggle'} id='contourButton' onClick={this.togglePlotModal.bind(this, 'contour')}>IDW Contour Layer</button>
            <button type="button" className={this.props.showClusters ? 'btn btn-info plot-toggle toggled-on' : 'btn btn-info plot-toggle'} id='clusterButton' onClick={this.togglePlotModal.bind(this, 'cluster')}>Cluster Properties</button>
            <button type="button" className={this.props.showQuantile ? 'btn btn-info plot-toggle toggled-on' : 'btn btn-info plot-toggle'} id='quantileButton' onClick={this.togglePlotModal.bind(this, 'quantile')}>Quantile Plot</button>
          </div>*/}

          <div className="plot-toggle-header" onClick={this.togglePropertyDetailsCollapsed.bind(this)} style={{'cursor': 'pointer'}}>
            <span><FontAwesome className="icon-right" name={this.state.propertyDetailsCollapsed ? 'chevron-right' : 'chevron-down'} /></span>
            <h5>Property Details</h5>
          </div>
          <div className={this.state.propertyDetailsCollapsed ? 'collapse' : 'collapse show'}>
          { !this.props.selectedProperty || propertyDetails === '' ?
            (<span style={{padding:'5px 30px'}}>Click on a parcel to display property details.</span>) :
            (<div style={{padding:'5px 30px'}}>
              <b>Initial Risk Rank: </b>{propertyDetails.get('m_risk_rank')}<br> 
              </br><b>Primary High Risk Issues: </b>{propertyDetails.get('m_issues')}<br>
              </br><b>TMK: </b>{propertyDetails.get('cty_tmk')}<br>
              </br><b>Description: </b>{propertyDetails.get('description')}<br>
              </br><b>Acreage: </b>{numeral(propertyDetails.get('acres')).format('0,0.[00]')}<br>
              </br><b>Fields: </b>{propertyDetails.get('hcs_fields')}<br></br>
              </div>)
          }
          </div>

          { this.props.parameterType === 'Discrete' ? (
            <div>
              <div className="plot-toggle-header" onClick={this.toggleHistogramCollapsed.bind(this)} style={{'cursor': 'pointer'}}>
                <span><FontAwesome className="icon-right" name={this.state.histogramCollapsed ? 'chevron-right' : 'chevron-down'} /></span>
                <h5>Bar Plot</h5>
              </div>
              <div className={this.state.histogramCollapsed ? 'collapse' : 'collapse show'}>
                <BarPlot
                  radius={this.props.parameter.value}
                  dispatch={this.props.dispatch}
                  data={plotValues.toJS()}
                  selection={this.props.histogram}
                  template={template.plot}
                  label={plotLabel}
                />
              </div>
            </div>
          ) : (
            <div>
              <div className="plot-toggle-header" onClick={this.toggleHistogramCollapsed.bind(this)} style={{'cursor': 'pointer'}}>
                <span><FontAwesome className="icon-right" name={this.state.histogramCollapsed ? 'chevron-right' : 'chevron-down'} /></span>
                <h5>Histogram</h5>
              </div>
              <div className={this.state.histogramCollapsed ? 'collapse' : 'collapse show'}>
                <ResultHistogram
                  min={0}
                  max={plotMax}
                  radius={this.props.parameter.value}
                  dispatch={this.props.dispatch}
                  data={plotData.toJS()}
                  selection={this.props.histogram}
                  template={template.plot}
                  label={plotLabel}
                />
              </div>
            </div>
          )}

          {/*<div className="plot-toggle-header" onClick={this.toggleAdditionalPropertyDetailsCollapsed.bind(this)} style={{'cursor': 'pointer'}}>
            <span><FontAwesome className="icon-right" name={this.state.additionalPropertyDetailsCollapsed ? 'chevron-right' : 'chevron-down'} /></span>
            <h5>Additional Property Details</h5>
          </div>
          <div className={this.state.additionalPropertyDetailsCollapsed ? 'collapse' : 'collapse show'}>
          { !this.props.selectedProperty || propertyDetails === '' ?
            (<span style={{padding:'5px 30px'}}>Click on a parcel to display property details.</span>) :
            (<div style={{padding:'5px 30px'}}>
              <b>TMK: </b>{propertyDetails.get('tmk')}<br>
              </br><b>Included? </b>{propertyDetails.get('include')}<br>
              </br><b>A&B Risk: </b>{propertyDetails.get('ab_risk_rank')}<br> 
              </br><b>Value: </b>{numeral(propertyDetails.get('value')).format('$0,0')}<br>
              </br><b>Owner: </b>{propertyDetails.get('owner')}<br>
              </br><b>Type: </b>{propertyDetails.get('parcel_type')}<br>
              </br><b>Description: </b>{propertyDetails.get('description')}<br>
              </br><b>Details: </b>{propertyDetails.get('details')}<br>
              </br><b>Notes: </b>{propertyDetails.get('notes') + ' ' + propertyDetails.get('parcel_notes')}<br>
              </br><b>HCS Fields: </b>{propertyDetails.get('hcs_fields')}<br>
              </br><b>Acres: </b>{numeral(propertyDetails.get('acres_owned')).format('0,0.[00]')}
              </div>)
          }
          </div>*/}
        </div>
      </div>
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.DataApp.get('filteredData'),
    properties: state.DataApp.get('filteredProperties'),
    unfilteredData: state.DataApp.get('data'),

    parameter: state.StatApp.get('parameter'),
    parameterType: state.StatApp.get('parameterType'),
    parameters: state.StatApp.get('parameters'),
    selectOptions: state.StatApp.get('selectOptions'),

    radius: state.StatApp.get('radius'),
    showProperties: state.StatApp.get('showProperties'),
    fillProperties: state.StatApp.get('fillProperties'),
    showInfoLegend: state.StatApp.get('showInfoLegend'),

    histogram: state.StatApp.get('histogramSelection'),
    
    selectedProperty: state.DataApp.get('selectedProperty'),
    selectedPropertyResults: state.DataApp.get('selectedPropertyResults'),
    selectedPropertyStaticResults: state.DataApp.get('selectedPropertyStaticResults'),
    
    showQuantile: state.StatApp.get('showQuantile'),
    quantileSize: state.StatApp.get('quantileSize'),
    
    showHotSpot: state.StatApp.get('showHotSpot'),
    
    showSamplingFreq: state.StatApp.get('showSamplingFreq'),
    
    showGrid: state.StatApp.get('showGrid'),
    
    showContours: state.StatApp.get('showContours'),
    
    showClusters: state.StatApp.get('showClusters'),
    
    showUITools: state.StatApp.get('showUITools'),
    uiSize: state.StatApp.get('uiSize'),
    
    errorMessage: state.StatApp.get('errorMessage'),
    template: state.Template
  }
}

const StatBar = connect(mapStateToProps)(StatBarComp)

export default StatBar;



// WEBPACK FOOTER //
// ./src/components/StatBar/index.js